import React, { useEffect } from 'react';
import BreadcrumbComp from '@components/UI/Breadcrumb/Index.jsx';
import Filter from "./Filter.jsx";
import { useGenericReducer } from '@hooks/state/useGenericReducer.js';
import SweetAlert from '@components/Feedback/SweetAlert/Index.jsx';
import GridRelatorioHistorico from './Grid.jsx';
import PageWrapper from '@components/UI/PageWrapper/Index.jsx';

function RelatorioHistorico() {

  useEffect(() => {
    SweetAlert.warningDevMode(
      "Aviso",
      "Esta tela está em desenvolvimento. Algumas funcionalidades podem não estar disponíveis no momento."
    );
  }, []);

  const NomeForm = "Relatório de Histórico";
  const { state, setData, addItem } = useGenericReducer();

  return (
    <PageWrapper>
      <div className="row">
        <BreadcrumbComp Param1="Home" Param2="Relatórios e Indicadores" Param3={NomeForm} />
        <div className="col-12 col-md-12">
          <div className="block h-auto">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-md-6 d-flex align-items-center">
                  <i className="fa-solid fa-filter filter-icon"></i>
                  <h2 className="mb-0 p-2">Filtros</h2>
                </div>
                <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                  <button className="btn btn-menu">
                    <i className="fa-solid fa-bars"></i>
                  </button>
                </div>

                <Filter onSave={addItem} />

                <GridRelatorioHistorico
                  state={state}
                  setData={setData}
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  )
}

export default RelatorioHistorico;